/**
 * Side-effect imports: generated protobuf JS copied from the shared
 * server protocol output. Do not edit generated files.
 */
import 'google-protobuf';
import '@locs/pb/IM.BaseDefine_pb.js';
import '@locs/pb/IM.Buddy_pb.js';
import '@locs/pb/IM.Call_pb.js';
import '@locs/pb/IM.File_pb.js';
import '@locs/pb/IM.Group_pb.js';
import '@locs/pb/IM.Login_pb.js';
import '@locs/pb/IM.Message_pb.js';
import '@locs/pb/IM.Other_pb.js';
import '@locs/pb/IM.Profile_pb.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getProto(): any {
  const p = (globalThis as Record<string, unknown>).proto;
  if (!p) {
    throw new Error('global proto not initialized; check pb-imports order');
  }
  return p;
}
